import { render } from "./QuizMeta.vue?vue&type=template&id=5518ccf4"
import script from "./QuizMeta.vue?vue&type=script&lang=js"
export * from "./QuizMeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__